<template>
	<div class="imgText">
		<div class="warp">
			<div class="account">
				1919年，在新文化运动的大潮中，山西第一座博物馆——山西教育图书博物馆在太原文庙诞生。1920年，向社会发出《征求名人书籍、出产等物的启示》，制定《对于慈善家捐助经济、书籍、物质，提倡并表纪念之条例》。社会各界人士共襄盛举，踊跃捐赠家藏，成为博物馆藏品的最早积淀，山西博物馆事业扬帆起航。
			</div>
			<div class="tab-content">
				<div>
					<dl v-for="(item,index) in allData" :key="index">
						<router-link tag="a" :to="{path:'pic',query:{id:item.id}}">
							<dt>
								<img :src="item.img" alt="">
							</dt>
						</router-link>
						<dd>
							<h3>{{item.title}}</h3>
							<p>{{item.etitle}}</p>
						</dd>
					</dl>
				</div>
			</div>
		</div>
		<div class="goback" @click="goback"></div>
	</div>
</template>
<script type="text/javascript">
    export default {
        data(){
            return{
                allData:[{
                    id:'unit1_01',
                    img:require('../static/imgs/proList1/proList1_01.jpg'),
                    title:' 草书五言诗轴',
                    etitle:'赵鹤（清）',
                    size:'纵154厘米，横38厘米',
                    donor:'常赞春先生捐赠'
                },{
                    id:'unit1_02',
                    img:require('../static/imgs/proList1/proList1_02.jpg'),
                    title:' 行书王昌龄《芙蓉楼送辛渐》诗轴',
                    etitle:'孙嘉淦（清）',
                    size:'纵175厘米，横77.5 厘米',
                    donor:'常赞春先生捐赠'
                },{
                    id:'unit1_03',
                    img:require('../static/imgs/proList1/proList1_03.jpg'),
                    title:' 行书元好问《换得云台帖，喜而赋诗》诗轴',
                    etitle:'孙嘉淦（清）',
                    size:'纵94.5厘米，横54 厘米',
                    donor:'常赞春先生捐赠'
                },{
                    id:'unit1_05',
                    img:require('../static/imgs/proList1/proList1_05.jpg'),
                    title:' 行书苏轼《跋石钟山记后》轴',
                    etitle:'祁世长（清）',
                    size:'纵118厘米，横49厘米',
                    donor:'常赞春先生捐赠'
                },{
                    id:'unit1_06',
                    img:require('../static/imgs/proList1/proList1_06.jpg'),
                    title:' 行书录《纯正蒙求》句轴',
                    etitle:'祁世长（清）',
                    size:'纵117厘米，横48厘米',
                    donor:'常赞春先生捐赠'
                },{
                    id:'unit1_07',
                    img:require('../static/imgs/proList1/proList1_07.jpg'),
                    title:' 《贾景伯嗜学图》轴',
                    etitle:'钱慧安（清）',
                    size:'纵109厘米，横49.5厘米',
                    donor:'常赞春先生捐赠'
                },{
                    id:'unit1_08',
                    img:require('../static/imgs/proList1/proList1_08.jpg'),
                    title:' 仿华喦《忘忧多子图》轴',
                    etitle:'温忠翰（清）',
                    size:'纵76.5厘米，横38.2厘米',
                    donor:'常赞春先生捐赠'
                },{
                    id:'unit1_09',
                    img:require('../static/imgs/proList1/proList1_09.jpg'),
                    title:' 山水轴',
                    etitle:'白恩佑（清）',
                    size:'纵47厘米，横31.5厘米',
                    donor:'常赞春先生捐赠'
                }]
            }
        },
        mounted(){
            this.curdata=this.allData;
        },
        methods:{
            goback(){
                if(window.history.length == 1){
                    this.$router.push({path:"/"})
                }else{
                    this.$router.go(-1)
                }
            }
        }
    }
</script>
<style scoped>
	.imgText{
		min-height:100%;
		background-color: #f1f1f1;
	}
	.goback{
		width: 1.63rem;
		height: 1.63rem;
		background:url(../static/imgs/goback.png);
		background-size: 100% 100%;
		position: fixed;
		right: .17rem;
		top:50%;
		margin-top: -.815rem;
	}
	.warp{
		margin: 0 auto;
		padding-top: .2rem;
	}
	.account{
		background: url('../static/imgs/account.png') no-repeat center / cover;
		width:6.3rem;
		height:3.22rem;
		margin:0 .24rem .4rem;
		padding:.3rem .36rem;
		font-size: .28rem;
		line-height: .46rem;
		letter-spacing: .02rem;
		color:#555;
	}
	.title{
		width: 100%;
		text-align: left;
		font-size:20px;
		position: relative;
		margin-bottom: .8rem;
	}
	.title span{
		text-indent:0.14rem;
		letter-spacing: 3px;
		display: inline-block;
		z-index: 3;
		position: absolute;
	}
	.title em{
		display: inline-block;
		width: 0.85rem;
		height:9px;
		background: #e6bb70;
		left: 0.20rem;
		position: absolute;
		z-index: 1;
		top:10px;
	}
	.cont{
		width: 90%;
		margin: 0 auto;
	}
	.cont p{
		font-size: 16px;
		color:#666666;
		line-height: 30px;
		text-align: justify;
		margin-bottom: .10rem;
	}
	.cont dl{
		width: 100%;
		margin-bottom:.10rem;
	}
	.cont dl dt img{
		width: 100%;
	}
	.cont dl dd{
		font-size:14px;
		color:#adadad;
		margin-top: 0.15rem;
		line-height: 20px;
	}
	.butn{
		/*background:url(../static/bj1.png);*/
		height:.4rem;
		background-size: 100%;
		margin-top:.25rem;
		position: relative;
	}
	.btnC{
		width: 0.45rem;
		height: 0.23rem;
		border-radius: 50px;
		background:#fff;
		box-shadow: 0px 1px 15px #ededed;
		text-align: center;
		line-height: 0.23rem;
		margin: 0 auto;
		margin-top: -0.11rem;
		position: absolute;
		left: 50%;
		margin-left: -0.25rem;
		color:#e6bb70;
	}
	.activeClass{
		height: 2rem;
		overflow:hidden;
	}
	.hideClass{
		height: auto;
	}
	.tab-tilte{
		width:1500px;
	}
	.tab-tilte li{
		float: left;
		width:1rem;
		padding: 10px 0;
		text-align: center;
		cursor: pointer;
		color:#cdcdcd;
		font-size: 18px;
		font-weight: bolder;
	}
	/* 点击对应的标题添加对应的背景颜色 */
	.tab-tilte .active{
		color: #e6bb70;
	}
	.tab-content div{
		padding-right: .4rem;
		margin-top:.2rem;
		column-count:2;
		padding-left: .03rem;
	}
	.tab-content div dl{
		margin-left: .2rem;
		width:3.4rem;
		background: #fff;
		display: inline-block;
		margin-bottom: .2rem;
		border-radius: .1rem;
	}
	.tab-content div dl dt{
		justify-content: center;
		align-items: center;
	}
	.tab-content div dl dt img{
		max-width:100%;
		max-height: 100%;
		border-radius: 4px 4px 0 0;
	}
	.tab-content div dl dd{
		padding-bottom: .46rem;
		background:#fff;
	}
	.tab-content h3{padding:.29rem .21rem .2rem;font-size: .28rem;line-height: normal;font-weight: bold;color:#333;}
	.tab-content p{padding:0 .21rem;color:#666;font-size: .24rem;}

</style>